import * as cl from "classnames"
import * as React from "react"

export default class CodeField extends React.Component<Props> {
	static id = "local-authority-detail-code"

	render() {
		const className = cl("input is-fullwidth", { "is-loading": this.props.loading })

		return <div className="field">
			<label className="label" htmlFor={CodeField.id}>
				Code Officiel Géographique
			</label>

			<div className="control">
				<input
				disabled={this.props.loading}
				className={className}
				id={CodeField.id}
				type="text"
				placeholder="49100"
				value={this.props.value || ""}
				required
				onChange={e => this.props.onChange(e.target.value)}/>
			</div>
		</div>
	}
}

interface Props {
	loading: boolean;
	value: string | null;
	onChange(value: string): void;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/code-field.tsx